module.exports = __webpack_public_path__ + "img/powered_by_vrify.6b6461f3.png";